export const getIndexByAttr = function(array, attr, value) {
    for (var i = 0; i < array.length; i += 1) {
        if (array[i] != null && array[i][attr] === value) {
            return i;
        }
    }
    return -1;
}

export const getByAttr = function(array, attr, value) {
    for (var i = 0; i < array.length; i += 1) {
        if (array[i] != null && array[i][attr] === value) {
            return array[i];
        }
    }
    return undefined;
}